import { useMediaQuery } from 'react-responsive';

export const useEpisodes = () => {
	const isExtraLarge = useMediaQuery({ query: '(max-width: 1100px)' });
	const isLarge = useMediaQuery({ query: '(max-width: 900px)' });
	const isMedium = useMediaQuery({ query: '(max-width: 700px)' });
	const isSmall = useMediaQuery({ query: '(max-width: 500px)' });
	const isExtraSmall = useMediaQuery({ query: '(max-width: 400px)' });

	let itemsToShow;
	switch (true) {
		case isExtraSmall:
			itemsToShow = 1;
			break;
		case isSmall:
			itemsToShow = 2;
			break;
		case isMedium:
			itemsToShow = 3;
			break;
		case isLarge:
			itemsToShow = 4;
			break;
		case isExtraLarge:
			itemsToShow = 5;
			break;
		default:
			itemsToShow = 7;
			break;
	}

	return { itemsToShow };
};
